import request from "@/router/axios";

export const getDetailPage = (data) => {
  return request({
    url: "/api/produce/store-sub/dynamic-inventory/detail/page",
    method: "post",
    data,
  });
};

export const getGroupPage = (groupType, data) => {
  return request({
    url: "/api/produce/store-sub/dynamic-inventory/group/page",
    method: "post",
    params: { groupType },
    data,
  });
};

export const getStatistics = (data) => {
  return request({
    url: "/api/produce/store-sub/dynamic-inventory/statistics",
    method: "post",
    data,
  });
};
